import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { CreateMeasurePopupComponent } from './create-measure/create-measure-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { SaveService } from '../../../../services/save.service';
import { FocusPlanListComponent } from './focusplan-list/focusplan-list.component';
import { MatTabGroup } from '@angular/material/tabs';
import { FocusPlanListImpactComponent } from './focusplanimpact-list/focusplanimpact-list.component';
import { FocusPlanListStatusComponent } from './focusplanstatus-list/focusplanstatus-list.component';
import { Router } from '@angular/router';
import { ExcelDownloadConfig, ExcelUploadConfig } from '../../../../interfaces/utils/excelbuttoninterface';
import { utils } from 'xlsx';

@Component({
    selector: 'focusplan',
    templateUrl: './focusplan.component.html',
    styleUrls: ['./focusplan.component.less'],
    standalone: false
})
export class FocusPlanComponent implements OnInit {

    label: string | undefined;
    measuresInfo!: MeasureInfo[];
    measureImpactsInfo!: MeasureImpactInfo[];
    waveId: number = -1;
    fiscalYear: number = 0;
    subscriptionWaveId: any;
    subscriptionFiscalYear: any;
    subscriptionBranch: any;
    @ViewChild('tabGroup') tabGroup!: MatTabGroup;
    selectedTabIndex = 0;
    isEditModeEnabled: boolean = false;
    isExcelModeEnabled: boolean = false;
    minMeasuresWarning = `**Please fill this page with minimum 4 to maximum 5 measures based on the assessment findings`;
    minActionItemsWarning = `**Please fill this page with minimum 3 action items based on the assessment findings. Fill in all the mandatory fields`;
    statusesQX!: any[];
    shouldReloadImpact: boolean = false;

    @ViewChild('focusPlanList', { static: true }) list!: FocusPlanListComponent;
    @ViewChild('focusPlanListStatus', { static: true }) viewList!: FocusPlanListStatusComponent;
    @ViewChild('focusPlanListImpact', { static: true }) viewImpactList!: FocusPlanListImpactComponent;

    excelDownloadConf: ExcelDownloadConfig = {
        fileName: 'FocusPlanDefinition'
    };

    excelUploadConf: ExcelUploadConfig = {};

    excelDownloadFinancialImpactConf: ExcelDownloadConfig = {
        fileName: 'FinancialImpact'
    };

    excelUploadFinancialImpactConf: ExcelUploadConfig = { };
    constructor(
        private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , private dialogForm: MatDialog
        , private toastrService: ToastrService
        , private router: Router
        , public saveService: SaveService
        , private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.subscriptionWaveId = this.defaults.wave$.subscribe(
            (waveId: number | undefined) => {
                if (waveId) {
                    this.waveId = waveId;
                    this.loadInformation(this.waveId);
                    if (this.selectedTabIndex === 1) {
                      this.loadFocusPlanImpact(this.waveId);
                      this.shouldReloadImpact = false;
                    } else {
                      this.shouldReloadImpact = true;
                    }
                    this.cdr.detectChanges(); // Manually trigger change detection
                    this.excelDownloadConf.downloadLink = `download/focus-plan/definition/${waveId}/${this.defaults.managementid}`;
                    this.excelUploadConf.uploadLink = "file/" + Utils.getFileUploadFocusPlanDefinition()
                    this.excelDownloadFinancialImpactConf.downloadLink = `download/focus-plan/financial-impact/${waveId}`;
                    this.excelUploadFinancialImpactConf.uploadLink = "file/" + Utils.getFileUploadFocusPlanFinancialImpact()
                }
            });
        this.subscriptionFiscalYear = this.defaults.fiscalYearMessageChanges$.subscribe(() =>
        {
            this.fiscalYear = this.defaults.fiscalYear;
            this.loadInformation(this.waveId)
            if (this.selectedTabIndex === 1) {
              this.loadFocusPlanImpact(this.waveId);
              this.shouldReloadImpact = false;
            } else {
              this.shouldReloadImpact = true;
            }
        });
        
        this.subscriptionBranch = this.defaults.managementIdMessageChanges$.subscribe(() =>
        {
            this.loadInformation(this.waveId)
            if (this.selectedTabIndex === 1) {
              this.loadFocusPlanImpact(this.waveId);
              this.shouldReloadImpact = false;
            } else {
              this.shouldReloadImpact = true;
            }
        });

        Utils.httpGetAvailableStatusesQX(
            this.http
            , this.baseUrl
            , this
            , function (tthis: FocusPlanComponent, result: any[]) {
                tthis.statusesQX = result
            },
            null
        );
        this.fiscalYear = this.defaults.fiscalYear;
    }

    ngOnDestroy() {
        this.subscriptionWaveId.unsubscribe();
        this.subscriptionFiscalYear.unsubscribe();
        this.subscriptionBranch.unsubscribe();
    }

    onTabChange(event: any) {
    if (event.index === 1 && this.shouldReloadImpact) {
            Utils.httpGetFocusPlanImpact(
                this.http
                , this.baseUrl
                , this.waveId
                , this
                , function (tthis: FocusPlanComponent, result: MeasureImpactInfo[]) {
                    tthis.measureImpactsInfo = result;
                    tthis.cdr.detectChanges(); // Manually trigger change detection
                }
                , function (tthis: FocusPlanComponent, error: string) {
                    tthis.toastrService.error('Cannot load focus plan impact for selected wave and Field Branch. Please, contact with administrator');
                }
            )
            this.shouldReloadImpact = false;
        }
    }

    loadInformation(waveId, reloadAll = false) {
        if (!waveId || waveId < 0) {
            this.label = `There is no assigned wave for ${this.defaults.managementid}`
            return;
        }
        //this.viewList.updatedItems = [];
        Utils.httpGetFocusPlanInformation(
            this.http
            , this.baseUrl
            , waveId
            , this
            , function (tthis: FocusPlanComponent, result: MeasureInfo[]) {
                setTimeout(() => {
                    tthis.measuresInfo = result;
                    tthis.measuresInfo.forEach((item, index) => {
                        item.ItemNo = index + 1;
                    });
                    tthis.cdr.detectChanges(); // Manually trigger change detection
                }, 50)
            }
            , function (tthis: FocusPlanComponent, error: string) {
                tthis.toastrService.error('Cannot load focus plan information for selected wave and Field Branch. Please, contact with administrator');
            }
        )

      if (reloadAll)
        this.loadFocusPlanImpact(waveId);
    }

    loadFocusPlanImpact(waveId) {
        Utils.httpGetFocusPlanImpact(
            this.http
            , this.baseUrl
            , this.waveId
            , this
            , function (tthis: FocusPlanComponent, result: MeasureImpactInfo[]) {
              tthis.measureImpactsInfo = result;
              tthis.cdr.detectChanges(); // Manually trigger change detection
            }
            , function (tthis: FocusPlanComponent, error: string) {
              tthis.toastrService.error('Cannot load focus plan impact for selected wave and Field Branch. Please, contact with administrator');
            }
        )
    }

    onRefresh() {
        this.loadInformation(this.waveId, true)
    }

    onRefreshPending() {
        this.loadInformation(this.waveId);
        this.shouldReloadImpact = true;
    }

    openCreateMeasurePopup() {
        if (this.canAddNewMeasure()) {
            const dialog = this.dialogForm.open(CreateMeasurePopupComponent, {
                panelClass: ['custom-mat-dialog_v2'],
                disableClose: true,
                data: { 'waveId': this.waveId },
            })

            dialog.afterClosed().subscribe((result) => {
              if (result?.event === 'submit') {
                this.loadInformation(this.waveId)
                this.shouldReloadImpact = true;
              }
            })
        }
    }

    showSaveButton() {
        return Object.keys(this.list?.clonedList).length > 0
    }

    canAddNewMeasure() {
        return this.list?.measuresInfo?.length < 5;
    }

    isMinMeasuresReached() {
        return this.list?.measuresInfo?.length > 2;
    }

    onClickEdit() {
        if (this.isEditModeEnabled === true) {
            this.isEditModeEnabled = false
            if (this.viewList.updatedItems.length > 0) {
                this.loadInformation(this.waveId)
            }
        }
        else {
            this.isEditModeEnabled = true
        }
    }

    onClickSave() {
        if (this.viewList?.updatedItems.length <= 0 && this.viewList?.updatedItems.length <= 0)
            this.isEditModeEnabled = false;
        if (this.viewList?.editedStatusComments.length > 0) {
            Utils.httpUpsertActionItemlist(
                this.http
                , this.baseUrl
                , this.viewList?.editedStatusComments
                , this
                , function (tthis: FocusPlanComponent, result: any) {
                    if (result) {
                        tthis.viewList.editedStatusComments = [];
                        tthis.isEditModeEnabled = false;
                        tthis.toastrService.success('Action Item Status Comments were saved successfully!');
                        tthis.loadInformation(tthis.waveId)
                    }
                    else
                        tthis.toastrService.error('Action Item Status Comments could not be saved. Please, contact with administrator');
                },
                null
            );
        }
        if (this.viewList?.updatedItems.length > 0)
            Utils.httpUpsertActionItemStatuses(
                this.http,
                this.baseUrl,
                this.viewList.updatedItems,
                this,
                function (tthis: FocusPlanComponent, result: any) {
                    if (result) {
                        tthis.viewList.updatedItems = [];
                        tthis.isEditModeEnabled = false;
                        tthis.toastrService.success('Action Item Statuses were saved successfully!');
                        tthis.loadInformation(tthis.waveId)
                    }
                    else
                        tthis.toastrService.error('Action Item Statuses could not be saved. Please, contact with administrator');
                },
                null
            )
        if (this.viewImpactList?.updatedItems.length > 0)
            Utils.httpUpsertFinancialImpact(
                this.http,
                this.baseUrl,
                this.waveId,
                this.viewImpactList.updatedItems,
                this,
                function (tthis: FocusPlanComponent, result: any) {
                    if (result) {
                        tthis.viewImpactList.updatedItems = [];
                        tthis.isEditModeEnabled = false;
                        tthis.toastrService.success('Targets were saved successfully!');
                        tthis.loadInformation(tthis.waveId, true)
                    }
                    else
                        tthis.toastrService.error('Targets could not be saved. Please, contact with administrator');
                },
                null
            )
        if (this.viewList?.updatedStatusQX.length > 0) {
            Utils.httpUpsertMeasureStatusQXList(
                this.http
                , this.baseUrl
                , this.viewList?.updatedStatusQX
                , this
                , function (tthis: FocusPlanComponent, result: any) {
                    if (result) {
                        tthis.viewList.updatedStatusQX = [];
                        tthis.isEditModeEnabled = false;
                        tthis.toastrService.success('Measure Statuses were saved successfully!');
                        tthis.loadInformation(tthis.waveId)
                    }
                    else
                        tthis.toastrService.error('Action Measure Statuses could not be saved. Please, contact with administrator');
                },
                null
            );
        }
    }

    onClickExcel() {
        this.isExcelModeEnabled = true;
        this.isEditModeEnabled = false;
    }

    onClickExitExcel() {
        this.isExcelModeEnabled = false;
    }

    onClickUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadFocusPlanStatus()]);
    }

    onClickDownload() {
        Utils.httpDownloadFocusPlanStatus(
            this.http,
            this.baseUrl,
            'focusPlanStatus',
            this.waveId,
            this.defaults.managementid
        );            
    }

    canEdit() {
        return this.defaults.isMersyAdminBranchExcellenceUser
            || this.defaults.isMersyBranchManagerBranchExcellenceUser
            || this.defaults.isMersyCoachBranchExcellenceUser;
    }
}
